var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6V5C6 2.79086 7.79086 1 10 1H19C21.2091 1 23 2.79086 23 5V14C23 16.2091 21.2091 18 19 18H18V19C18 21.2091 16.2091 23 14 23H5C2.79086 23 1 21.2091 1 19V10C1 7.79086 2.79086 6 5 6H6ZM10 2.5H19C20.3807 2.5 21.5 3.61929 21.5 5V14C21.5 15.3807 20.3807 16.5 19 16.5H18V10C18 7.79086 16.2091 6 14 6H7.5V5C7.5 3.61929 8.61929 2.5 10 2.5ZM5 7.5H14C15.3807 7.5 16.5 8.61929 16.5 10V19C16.5 20.3807 15.3807 21.5 14 21.5H5C3.61929 21.5 2.5 20.3807 2.5 19V10C2.5 8.61929 3.61929 7.5 5 7.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.ae1dcec800c86fb1c8fca7744dd752b3.svg";
export { ForwardRef as ReactComponent };